import * as React from 'react';
import AppConfig from '../AppConfig';
import { makeArticleJsonLd, makeProductJsonLd } from '../utils/jsonld';
export function JsonLd({ object }) {
    return (React.createElement("script", { type: "application/ld+json", dangerouslySetInnerHTML: {
            __html: JSON.stringify(object),
        } }));
}
export function ArticleJsonLd({ entity }) {
    return (React.createElement(AppConfig, null, appData => {
        const schema = makeArticleJsonLd(entity, appData);
        return (React.createElement("script", { type: "application/ld+json", dangerouslySetInnerHTML: { __html: JSON.stringify(schema) } }));
    }));
}
export function ProductJsonLd({ entity }) {
    return (React.createElement(AppConfig, null, appData => {
        const schema = makeProductJsonLd(entity, appData);
        return (React.createElement("script", { type: "application/ld+json", dangerouslySetInnerHTML: { __html: JSON.stringify(schema) } }));
    }));
}
//# sourceMappingURL=index.js.map